export type EvaluationVersion = number;
export const DEFAULT_EVALUATION_VERSION: EvaluationVersion = 2;
